module.exports = __webpack_public_path__ + "static/media/Невский М.В..db403fa6.pdf";